export async function requestServices(path, signal) {
  const controller = new AbortController();
  const cancel = () => controller.abort();
  signal?.addEventListener("abort", cancel, { once: true });
  if (signal?.aborted) cancel();
  const timer = setTimeout(cancel, 20000);
  try {
    const response = await fetch("/api/site/v1/" + path, {
      credentials: "omit",
      cache: "no-store",
      redirect: "error",
      signal: controller.signal,
    });
    const result = await response.json();
    if (response.status === 404 && result?.error?.code === "not_found")
      return null;
    if (!response.ok || !Object.hasOwn(result, "data"))
      throw Error("unavailable");
    return result.data;
  } catch (error) {
    if (signal?.aborted) throw error;
    throw Error(
      "Services could not connect to the website. Please try again later.",
    );
  } finally {
    clearTimeout(timer);
    signal?.removeEventListener("abort", cancel);
  }
}
export async function getServiceCatalogue(placement, signal) {
  if (!["homepage", "services"].includes(placement))
    throw Error("Invalid placement");
  const result = await requestServices(
    "service-catalogue?placement=" + placement,
    signal,
  );
  if (!Array.isArray(result?.items)) throw Error("Invalid services catalogue");
  return result.items;
}
export const getPublicService = (slug, signal) =>
  /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug || "")
    ? requestServices("services/by-slug/" + slug, signal)
    : Promise.resolve(null);
